export default __webpack_public_path__ + "static/7-3--1645675c8bb0405bdccee05867625958.png";